import { OverlayType } from '../constants/common'
import { dateFromUnixTimestamp } from '../utils'
import { MainCalculation, OnValueCalculated } from './main'

type Options = {
  period: number
}

const datesAreOnSameDay = (first: Date, second: Date) =>
  first.getFullYear() === second.getFullYear() &&
  first.getMonth() === second.getMonth() &&
  first.getDate() === second.getDate()

type DefaultCalculatedValuesType = {
  vwap: number[]
}

export class VWapCalculation extends MainCalculation<Options, DefaultCalculatedValuesType> {
  static type = OverlayType.Vwap

  getDefaultCalculatedValues() {
    return { vwap: [] }
  }

  calculate(onValueCalculated?: OnValueCalculated<typeof this.calculatedValues>) {
    const { date, close, low, high, volume } = this.quote
    const lastIndex = date.length - 1
    this._calculatedValues = this.getDefaultCalculatedValues()

    let cumulativePV = 0
    let cumulativeVolume = 0

    for (let i = 0; i <= lastIndex; i++) {
      if (i > 0) {
        const prevDate = dateFromUnixTimestamp(date[i - 1])
        if (!datesAreOnSameDay(prevDate, dateFromUnixTimestamp(date[i]))) {
          cumulativePV = 0
          cumulativeVolume = 0
        }
      }

      const typicalPrice = (close[i] + low[i] + high[i]) / 3
      const pv = typicalPrice * volume[i]

      cumulativePV += pv
      cumulativeVolume += volume[i]

      this.calculatedValues.vwap[i] = cumulativePV / cumulativeVolume

      if (onValueCalculated?.(this.calculatedValues, i) === false) {
        break
      }
    }
  }
}
